import create from './create';
import get from './get';
import getOne from './getOne';
import del from './del';
import edit from './edit';
import countAll from './countAll';
import getAddress from './getAddress';

export default {
  create,
  get,
  getOne,
  del,
  edit,
  countAll,
  getAddress,
};



// WEBPACK FOOTER //
// ./src/services/customer/index.js